module.exports = __webpack_public_path__ + "static/media/Features 3.2cc80ca6.svg";